import React, { Component } from 'react';
import {ButtonGroup, Button, Label} from 'react-bootstrap';

class FormTags extends Component {

   /*****************************************/
   /* FUNCTION */
   /*****************************************/
   returnButtonStyle(check) {
      return (this.props.filterTag === check) ? "success" : "primary"
   }

   /*****************************************/
   /* HANDLE */
   /*****************************************/
   handleFilterTagCLick(filterTag) {this.props.onFilterTag(filterTag)}

   /*****************************************/
   /* RENDER */
   /*****************************************/
   render() {

      return (
         <div>
            <div className="bloc-tags-lg hidden-xs">
               <Button bsStyle={this.returnButtonStyle("tag1")}
                  onClick={this.handleFilterTagCLick.bind(this, 'tag1')}>tag <Label bsStyle="success">1</Label></Button>
               <div className="push-sm"></div>
               <Button bsStyle={this.returnButtonStyle("tag2")}
                  onClick={this.handleFilterTagCLick.bind(this, 'tag2')}>tag <Label bsStyle="success">2</Label></Button>
               <div className="push-sm"></div>
               <Button bsStyle={this.returnButtonStyle("tag3")}
                  onClick={this.handleFilterTagCLick.bind(this, 'tag3')}>tag <Label bsStyle="success">3</Label></Button>
               <div className="push-sm"></div>
               <h3 className="counter text-center text-primary"><b>{this.props.count}</b></h3>
            </div>

            <div className="bloc-tags-xs visible-xs-block">
               <ButtonGroup>
                  <Button bsStyle={this.returnButtonStyle("tag1")}
                     onClick={this.handleFilterTagCLick.bind(this, 'tag1')}>tag <Label bsStyle="success">1</Label></Button>
                  <Button bsStyle={this.returnButtonStyle("tag2")}
                     onClick={this.handleFilterTagCLick.bind(this, 'tag2')}>tag <Label bsStyle="success">2</Label></Button>
                  <Button bsStyle={this.returnButtonStyle("tag3")}
                     onClick={this.handleFilterTagCLick.bind(this, 'tag3')}>tag <Label bsStyle="success">3</Label></Button>
               </ButtonGroup>
               <h3 className="counter pull-right text-primary">{this.props.count}</h3>
            </div>
         </div>
      )
   }
}

export default FormTags;



// WEBPACK FOOTER //
// ./src/FormTags.js